import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

type SchemaTablesCountResponse = {
  paging: {
    total: number;
  };
};

export const fetchSchemaTablesCount = async (schemaFqn: string): Promise<number> => {
  const response = await openMetadataApiClient.get<SchemaTablesCountResponse>('/tables', {
    params: {
      limit: 1,
      databaseSchema: schemaFqn,
      include: 'non-deleted',
    },
  });

  return response.data.paging.total;
};
